module.exports = function() {
  return new Worker(__webpack_public_path__ + "0d48427cb56bb56d05ba.worker.js");
};